import { render, staticRenderFns } from "./PinnedSection.vue?vue&type=template&id=28052a2a&scoped=true"
import script from "./PinnedSection.vue?vue&type=script&lang=ts"
export * from "./PinnedSection.vue?vue&type=script&lang=ts"
import style0 from "./PinnedSection.vue?vue&type=style&index=0&id=28052a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28052a2a",
  null
  
)

export default component.exports